import { Component, OnInit, Input, ViewChild, ChangeDetectorRef } from '@angular/core';
import * as moment from 'moment';
import { ComponentBase } from 't4core';
import { EntityEventInfo, EntityType } from 't4core';
import { T4DatatableWidget } from '../datatable/datatable';
import { T4EntityAttachment } from '../../dialogs/entityattachment/entityattachment';

@Component({
  selector: 't4-entity-event',
  templateUrl: './entityevent.html',
  styleUrls: ['./entityevent.css']
})

export class T4EntityEvent extends ComponentBase implements OnInit {
  public entityEvents: EntityEventInfo[] = [];
  public notificationEvents: EntityEventInfo[] = [];
  public filteredItems: EntityEventInfo[] = [];
  public searchQuery: string = "";
  public isLoading: boolean = false;
  //public currentPage: number = 1;
  //public pageSize: number = 10;

  @ViewChild("tblEntityEvents", { static: false }) tblEntityEvents: T4DatatableWidget;
  @Input() entityId: string = "";
  @Input() entityType: EntityType = undefined;

  constructor(private cdr: ChangeDetectorRef) {
    super();
  }

  public async ngOnInit() {
    await this.loadData();
  }

  private async loadData() {
    this.isLoading = true;
    if (this.entityId != "" && this.entityType != undefined) {
      try {
        this.entityEvents = await this.Api.get<EntityEventInfo[]>("/Data/GetEntityEvents", { entityId: this.entityId, entityType: this.entityType });
        this.notificationEvents = await this.Api.get<EntityEventInfo[]>("/Data/GetEntityEvents", { entityId: this.entityId, entityType: EntityType.Notification });
        this.entityEvents = [...this.entityEvents, ...this.notificationEvents].sort((a, b) => moment(b.CreatedAt).valueOf() - moment(a.CreatedAt).valueOf());
      } catch (error) {
        console.error("Error loading data: ", error);
      } finally {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    }
  }

  public showEventDetails(e: EntityEventInfo) {
    alert(e.Notes);
  }

  public async addEvent() {
    if (this.entityId == "") return;

    var note = await this.UI.prompt("Turbo.Core.EntityEvent.headComment", "Add event log", "Turbo.Core.EntityEvent.Comment", "Enter log here");

    if (note) {

      var noteCreated = await this.Api.get<boolean>("Data/AddEntityEvent", { entityId: this.entityId, entityType: this.entityType, message: note });

      if (noteCreated) {
        this.UI.alert("Turbo.Core.EntityEvent.headCommentCreated", "Log created!", "Turbo.Core.EntityEvent.msgAddedeventlog", "The log has been added successfully.");
        await this.loadData();
      }
      else {
        this.UI.alert("Turbo.Core.EntityEvent.headCommentFailed", "Failed!", "Turbo.Core.EntityEvent.msgAddeventlogFailed", "Something went wrong. Please try again.");
      }
    }
  }

  public async showAttachment(entityId: string) {
    const result = await this.Dialog.open(T4EntityAttachment, { data: { EntityId: entityId } }).afterClosed().toPromise();
  }

  public filterSearch(): void {
    this.filteredItems = this.entityEvents.filter(item =>
      item.Notes.toLowerCase().includes(this.searchQuery.toLowerCase()));
    //this.currentPage = 1;
  }

  //public get totalPages(): number {
  //  return Math.ceil(this.filteredItems.length / this.pageSize);
  //}

  public get visibleItems(): EntityEventInfo[] {
    //const startIndex = (this.currentPage - 1) * this.pageSize;
    //return this.filteredItems.slice(startIndex, startIndex + this.pageSize);
    return this.filteredItems;
  }

  public async RefreshData() {
    await this.loadData();
    this.UI.alert("turbo.core.entityevent.RefreshDataPopup", "Refresh completed", "turbo.core.entityevent.msgRefreshDataPopup1", "The logs are updated from database.");
  }
}
